export const LAZY_LOAD_MARGIN = 2;

export const MAX_IMAGE_HEIGHT = 640;
export const IMAGE_PIXEL_DENSITY = 2;
